"use strict";
/**
 * @enum CustodianId
 * @description Defines the custodians configured in integrations gateway
 */
exports.__esModule = true;
exports.isCustodian = exports.CustodianId = void 0;
// IMPORTANT: when adding a new value to this enum, also add a new orderId sequence (e.g., order_id_matrix).
var CustodianId;
(function (CustodianId) {
    CustodianId["matrix"] = "matrix";
    CustodianId["superomni"] = "superomni";
    CustodianId["sample"] = "sample";
    CustodianId["bnyTreasury"] = "bnyTreasury";
})(CustodianId = exports.CustodianId || (exports.CustodianId = {}));
var isCustodian = function (source) {
    return !!CustodianId[source]; // need to assert here since we are wanting to accept arbitrary strings as the source
};
exports.isCustodian = isCustodian;
